import type { ImportVertex, RoofHalfEdge, RoofVertex } from "building-types/roofVolumes/roofVolumeTypes";
import type { Vec3 } from "geom/vec3";

// For each half-edge connect it to its previous half-edge in the face.
// The face is oriented counter-clockwise.
export function connectHalfEdges(vertex: RoofVertex) {
  const n = vertex.halfEdges.length;
  for (let i = 0; i < n; i++) {
    const nextHalf = vertex.halfEdges[i];
    const prevHalf = vertex.halfEdges[(i + 1) % n].twin;
    if (prevHalf) {
      nextHalf.prev = prevHalf;
      prevHalf.next = nextHalf;
    }
  }
}

// Create a half-edge with the given vertex.
export function createHalfEdge(vertex: RoofVertex) {
  const ray = { halfEdges: [] };

  const half: RoofHalfEdge = { origin: vertex, convex: true };
  const twin: RoofHalfEdge = { origin: ray, convex: true };
  half.twin = twin;
  twin.twin = half;
  return half;
}

// Create a vertex with rays pointed in different directions.
// numRays is the number of directions.
export function createVertex(position: Vec3, numRays: number): RoofVertex {
  const center: RoofVertex = { position, halfEdges: [] };
  for (let i = 0; i < numRays; i++) {
    const half = createHalfEdge(center);
    center.halfEdges.push(half);
  }
  connectHalfEdges(center);
  return center;
}

// Export a vertex into a format that can be imported.
export function exportVertex(vertex: RoofVertex, halfEdges: RoofHalfEdge[]): ImportVertex {
  return {
    position: vertex.position,
    dir: vertex.dir,
    halfEdges: vertex.halfEdges.map((half) => halfEdges.indexOf(half)),
  };
}
